import { v4 as uuid } from "uuid";
/**
 * Database of Videos 
 * */

export const videos = [
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/9c6152d02584be0e207acadf4acb485f/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Relaxing Painterly Mandalas in Procreate",
    creator: "Jennifer Nichols",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 1000,
    tag: 'Staff Pick',
    duration: '1h 50m',
    dateCreated: new Date('Mar 3 2022'),
    rating: 5,
    categoryName: 'Digital Art', // Illustration
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/171d2bc265d34936d86ecf0981832270/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Procreate Animation: Make Fun GIFs & Videos",
    creator: "Rich Armstrong",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 4250,
    tag: 'Staff Pick',
    duration: '4h 21m',
    dateCreated: new Date('Mar 20 2022'),
    rating: 3,
    categoryName: 'Digital Art',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/uploads/video/thumbnails/cfa4f7b3e8b769ebacbe9348a8b55c35/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Neural Networks from Scratch - P.1 Intro and Neuron Code",
    creator: "Sentdex",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 4250,
    tag: 'Trending',
    duration: '4h 21m',
    dateCreated: new Date('Mar 18 2022'),
    rating: 2,
    categoryName: 'Painting',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: 'https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/a023b8c9f901e0628f328ee2a9690843/original',
    title: "How to Illustrate with Fabric & Thread: The Art of Fusible Appliqué",
    creator: "Lauren Weber",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 6000,
    tag: 'Staff Pick',
    duration: '4h 05m',
    dateCreated: new Date('Mar 1 2022'),
    rating: 5,
    categoryName: 'Illustration',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: 'https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/9e1c7c6156c4bafb5d3141f135b20d7f/original',
    title: "Urban Sketching: Draw Characteristic Old City Charm With One Point Perspective",
    creator: "Peggy Dean",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 6000,
    tag: 'Trending',
    duration: '42m',
    dateCreated: new Date('Mar 1 2022'),
    rating: 5,
    categoryName: 'Sketching',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: 'https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/1b3674912ed25d189fdee3dd14fb14b1/original',
    title: "Modern Watercolor Techniques: Explore Skills to Create On-Trend Paintings",
    creator: "Cat Coquillette",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 6000,
    tag: 'Trending',
    duration: '1h 20m',
    dateCreated: new Date('Mar 1 2022'),
    rating: 4,
    categoryName: 'Painting',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: 'https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/75f36a0cb032aeee5e14501083e038c5/original',
    title: "Adventures in Gouache: Painting and Pattern Making Techniques",
    creator: "Kate Cooke",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 200,
    tag: 'New',
    duration: '20m',
    dateCreated: new Date('Apr 3 2022'),
    rating: 3,
    categoryName: 'Painting',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/a8a149db6f4b78b1cf36e6483798164b/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Learn to Draw: Daily Practices to Improve Your Drawing Skills",
    creator: "Gabrielle Brickey, Portrait Artist",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 1000,
    tag: 'Staff Pick',
    duration: '1h24m',
    dateCreated: new Date('Mar 28 2022'),
    rating: 4,
    categoryName: 'Sketching',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/1c61db4ed1ff443ede2d2b0c8c8c07dc/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Basic Skills: Getting Started with Drawing",
    creator: "Brent Eviston, Master Artist & Instructor",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 4250,
    tag: 'New',
    duration: '4h21m',
    dateCreated: new Date('Mar 27 2022'),
    rating: 3,
    categoryName: 'Sketching',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/uploads/video/thumbnails/3e89040101be0f95c0b45077afab48c3/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Design and create Digital Art for print",
    creator: "Cot Cotiqque",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 8000,
    tag: 'Staff Pick',
    duration: '21m',
    dateCreated: new Date('Mar 30 2022'),
    rating: 5,
    categoryName: 'Digital Art',
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
  {
    _id: uuid(),
    img_src: "https://static.skillshare.com/cdn-cgi/image/width=448,quality=85,format=auto/uploads/video/thumbnails/5d26c0cc1d5bf0e8f6a02b8685301521/original",
    url: "https://www.youtube.com/embed/-c3L90nsesw",
    title: "Drawing Seamless Patterns in Procreate + Professional Surface Design Tips",
    creator: "Cot Cotiqque",
    creator_pic: "https://static.skillshare.com/uploads/users/9431446/user-image-small.jpg?1061042872",
    views: 10000,
    tag: 'Staff Pick',
    duration: '50m',
    dateCreated: new Date('Mar 3 2022'),
    rating: 5,
    categoryName: 'Illustration', // Digital Art
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias.",
  },
];